import _ from 'lodash';
import Debug from '@/util/debug';
import parseError, { ERROR_MODEL_NOT_FOUND } from '@/util/parse-error';
import NotFound from '@/components/not-found/NotFound.vue';
import Loading from '@/components/loading/Loading.vue';
import { swiper, swiperSlide } from 'vue-awesome-swiper';

const debug = Debug('campaign-wrapper');
const breakpointMd = 767;

export default {
  dependencies: [
    'draftService',
    'stepService',
  ],
  components: {
    'not-found': NotFound,
    loading: Loading,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      loading: true,
      error: null,
      steps: null,
      availableSteps: null,
      campaign: null,
      swiperOptions: {
        notNextTick: true,
        slidesPerView: 5,
        spaceBetween: 20,
        noSwiping: true,
        breakpoints: {
          [breakpointMd]: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        },
      },
    };
  },
  computed: {
    currentStep() {
      if (this.steps) {
        const step = this.steps.find(st => st.route === this.$route.name);
        if (step) {
          if (this.$refs.stepSwiper) {
            this.$refs.stepSwiper.swiper.slideTo(step.id - 2);
          }
          return step;
        }
      }
      return {};
    },
    notFound() {
      return this.error && this.error.indexOf(ERROR_MODEL_NOT_FOUND) !== -1;
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler: function watchRoute() {
        if (!_.has(this.$route, 'params.noReFetch')) {
          this.fetchData();
        }
      },
    },
  },
  methods: {
    fetchData() {
      const fin = () => {
        debug.info('finished loading. error: %o', this.error);
        this.loading = false;
      };

      this.error = null;
      this.loading = true;
      const campaignId = this.$route.params.id;

      const routeName = this.$route.name;
      Promise.all([
        this.stepService.getSteps().then(res => this.steps = res),
        (campaignId === 'new' ? this.draftService.getNew() : this.draftService.getById(campaignId))
          .then((c) => {
            this.campaign = c;
            this.availableSteps = this.stepService.getAvailableSteps(this.campaign);
            debug.info('available steps: %o', this.availableSteps);
            if (!this.stepService.isStepAvailable(this.campaign, routeName)) {
              this.$router.replace({
                name: this.availableSteps[this.availableSteps.length - 1],
                params: {
                  campaignId,
                  noReFetch: true,
                },
              });
            }
          }),
      ])
      .then(fin)
      .catch((e) => {
        this.error = parseError(e);
        this.availableSteps = null;
        fin();
      });
    },
    goToStep(routeName) {
      const campaignId = this.campaign.id;
      if (this.$route.name !== routeName
          && this.stepService.isStepAvailable(this.campaign, routeName)) {
        // Force campaign data saving
        const promise = this.$route.name === 'campaign-settings'
          ? this.draftService.updateDraft(campaignId, this.campaign)
          : Promise.resolve(campaignId);

        promise
          .then(id => {
            this.$router.push({
              name: routeName,
              params: { id },
            });
          });
      }
    },
    getStepName(routeName) {
      return `link_steps_to${routeName.replace(/-/g, '_')}`;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/campaign-wrapper/CampaignWrapper.js